import React from "react";

function PDFIcon() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 2H4V30H28V10L20 2Z"
        fill="#E03B24"
      />
      <path d="M20 2L28 10H20V2Z" fill="#B61D08" />
      <path
        d="M24.5517 20.6082H21.7037V21.9442H23.9517V22.8402H21.7037V25.0002H20.5997V19.7202H24.5517V20.6082Z"
        fill="white"
      />
      <path
        d="M16.4897 19.7202C17.3164 19.7202 17.9564 19.9495 18.4097 20.4082C18.863 20.8615 19.0897 21.5122 19.0897 22.3602C19.0897 23.2029 18.863 23.8535 18.4097 24.3122C17.9564 24.7709 17.3164 25.0002 16.4897 25.0002H14.4497V19.7202H16.4897ZM16.4337 24.1202C16.935 24.1202 17.311 23.9709 17.5617 23.6722C17.8177 23.3682 17.9457 22.9309 17.9457 22.3602C17.9457 21.7895 17.8177 21.3549 17.5617 21.0562C17.311 20.7522 16.935 20.6002 16.4337 20.6002H15.5537V24.1202H16.4337Z"
        fill="white"
      />
      <path
        d="M11.0938 19.7202C11.4992 19.7202 11.8458 19.7895 12.1338 19.9282C12.4218 20.0615 12.6432 20.2562 12.7978 20.5122C12.9578 20.7629 13.0378 21.0669 13.0378 21.4242C13.0378 21.7815 12.9578 22.0882 12.7978 22.3442C12.6432 22.5949 12.4218 22.7895 12.1338 22.9282C11.8458 23.0615 11.4992 23.1282 11.0938 23.1282H9.98184V25.0002H8.87784V19.7202H11.0938ZM10.9258 22.2562C11.2565 22.2562 11.5045 22.1869 11.6698 22.0482C11.8352 21.9042 11.9178 21.6962 11.9178 21.4242C11.9178 21.1469 11.8352 20.9389 11.6698 20.8002C11.5045 20.6615 11.2565 20.5922 10.9258 20.5922H9.98184V22.2562H10.9258Z"
        fill="white"
      />
    </svg>
  );
}

export default PDFIcon;
